;(function () {
  'use strict'

  angular
    .module('contrast.time-series')
    .directive('csSparklineTime', ['dc', 'crossfilterService', csSparklineTime])

  function csSparklineTime(dc, crossfilterService) {
    var uniqueId = 1

    return {
      restrict: 'EA',
      scope: {
        data: '=',
        fillHeight: '='
      },
      link: link
    }

    function link($scope, element) {
      var id = 'sparkline-' + uniqueId++
      var parent = element.parent()
      var rendering = false
      var renderers = 0
      var fillHeight = $scope.fillHeight

      element.attr('id', id)

      $scope.$watch(
        function () {
          return $scope.data ? $scope.data.data : false
        },
        function (newValue) {
          if (newValue) {
            renderChart(true)
          }
        }
      )

      $scope.$watch(
        function () {
          return parent.width()
        },
        function (newValue, oldValue) {
          if (newValue && newValue !== oldValue) {
            renderChart(true)
          }
        }
      )

      function renderChart(force) {
        var parentWidth = parent.width(),
          siblingWidth = 0

        parent.children().each(function (index, ele) {
          if (ele.id !== element[0].id) {
            siblingWidth += angular.element(ele).width()
          }
        })

        var chartWidth = parentWidth - siblingWidth - 10
        if (chartWidth < 0) {
          return
        }

        if (
          $scope.data &&
          $scope.data.data &&
          $scope.data.data.length > 1 &&
          (!rendering || force)
        ) {
          rendering = true
          renderers++

          element.addClass('sparkline-loading')

          var ndx = crossfilterService($scope.data.data),
            timeDimension = ndx.dimension($scope.data.config.dimension)

          var height = 40
          if (fillHeight) {
            var topPadding = parseInt(
                element.css('padding-top').replace('px', '')
              ),
              bottomPadding = parseInt(
                element.css('padding-top').replace('px', '')
              ),
              verticalPadding = topPadding + bottomPadding

            height = parent.height() - verticalPadding
            if (height <= 0) {
              height = 1
            }
          }

          var valueGroup = timeDimension
            .group()
            .reduceSum($scope.data.config.group)
          var lineChart = dc
            .lineChart('#' + id)
            .width(chartWidth)
            .height(height)
            .clipPadding(10)
            .margins({ left: -4, top: 4, right: -4, bottom: 4 })
            .x($scope.data.config.xScale)
            .y($scope.data.config.yScale)
            .brushOn(false)
            .dimension(timeDimension)
            .group(valueGroup)

          lineChart.on('postRender', function (chart) {
            var classAccessor = $scope.data.config.classAccessor,
              valAccessor = $scope.data.config.group,
              gradientId = 'linear_gradient_' + id

            if (angular.isFunction(classAccessor)) {
              var defs = chart.select('defs')
              var linearGradient = defs
                .append('linearGradient')
                .attr('id', gradientId)
                .attr('x1', '0%')
                .attr('y1', '100%')
                .attr('x2', '0%')
                .attr('y2', '0%')

              var allRecords = timeDimension.top(Infinity)
              allRecords.sort(function (a, b) {
                return valAccessor(a) - valAccessor(b)
              })

              var maxVal = valAccessor(allRecords[allRecords.length - 1]),
                minVal = valAccessor(allRecords[0]),
                diff = maxVal - minVal,
                value

              for (var i = 0; i <= 10; i++) {
                value = minVal + (diff / 10) * i
                linearGradient
                  .append('stop')
                  .attr('offset', i * 10 + '%')
                  .classed(classAccessor(value), true)
              }

              chart
                .select('.stack._0 .line')
                .attr('stroke', 'url(#' + gradientId + ')')
            } else {
              chart.select('.stack._0 .line').classed(classAccessor, true)
            }

            rendering = false
            renderers--

            if (renderers === 0) {
              element.removeClass('sparkline-loading')
            }
          })

          lineChart.render()
        }
      }
    }
  }
})()
